import { TDispatch } from 'state';
import ErrorNotifier from '../../../../../services/error-notifier';
import { removeFromBlocklist, removeFromAllowlist } from '../../api/allow-and-block-list';
import { User } from '../types';
import { removeUserSuccess } from './../../../users/state/actions/index';
import { getModerationUserType } from './add-to-blocklist-or-allowlist';

type Options = {
  type: 'BLOCKLIST' | 'ALLOWLIST';
  user: User;
  userId?: string;
  ip?: string;
  applyOnHistory?: boolean;
};

const api = {
  BLOCKLIST: removeFromBlocklist,
  ALLOWLIST: removeFromAllowlist
};

const removeFromBlocklistOrAllowlist = ({
  ip,
  user,
  userId,
  applyOnHistory = false,
  type = 'BLOCKLIST'
}: Options) => {
  return async (dispatch: TDispatch): Promise<void> => {
    try {
      await api[type]?.({ ip, userId, applyOnHistory });
      dispatch(removeUserSuccess({ type: getModerationUserType(type, ip), userId, user, ip }));
    } catch (error) {
      console.error(error);
      ErrorNotifier.notifyError(`Failed to add to allow / block list`, { userId, ip, type });
    }
  };
};

export default removeFromBlocklistOrAllowlist;
